'use client';

import { AppImageClient, AppImageData } from '@components/appImage';
import { Card } from '@components/card';
import { Typography } from '@components/typography';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

type RouteAndTasksItem = {
  id: string;
  title: string;
  description: string;
  imgSrcKey: string;
};

export const RouteAndTasksSection = ({
  items,
  imagesDataMap,
}: {
  items: RouteAndTasksItem[];
  /** Данные AppImage по imgSrcKey из `getAppImagesData`. */
  imagesDataMap: Record<string, AppImageData>;
}) => {
  return (
    <>
      <Card className="flex p-12 max-sm:hidden" variant="subtle">
        {items.map((item) => (
          <div key={item.id} className="flex flex-1 basis-0 flex-col gap-7">
            <div className="flex flex-col gap-2.5">
              <Typography variant="heading-s">{item.title}</Typography>
              <Typography variant="text-s">{item.description}</Typography>
            </div>
            <AppImageClient
              {...imagesDataMap[item.imgSrcKey]}
              alt={item.title}
              className="h-auto w-[244px] object-contain"
            />
          </div>
        ))}
      </Card>

      <div className="md:hidden">
        <Card className="p-5 pb-0" variant="subtle">
          <Swiper
            className="route-and-tasks-mobile-swiper w-full! min-w-0"
            modules={[Pagination, Navigation]}
            pagination={{ clickable: true }}
            navigation
            spaceBetween={12}
            slidesPerView={1}
            observer
            updateOnWindowResize
            watchOverflow
          >
            {items.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="flex flex-col gap-3">
                  <div className="flex flex-col gap-2.5">
                    <Typography variant="heading-s">{item.title}</Typography>
                    <Typography variant="text-m">{item.description}</Typography>
                  </div>
                  <div className="flex justify-center">
                    <AppImageClient
                      {...imagesDataMap[item.imgSrcKey]}
                      alt={item.title}
                      className="h-auto w-[207px] object-contain"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Card>

        <style jsx global>{`
          .route-and-tasks-mobile-swiper {
            width: 100%;
          }

          .route-and-tasks-mobile-swiper .swiper-wrapper {
            align-items: center;
          }

          .route-and-tasks-mobile-swiper .swiper-slide {
            width: 100% !important;
          }

          .route-and-tasks-mobile-swiper .swiper-button-prev,
          .route-and-tasks-mobile-swiper .swiper-button-next {
            top: 50%;
            width: 44px;
            height: 44px;
            margin-top: 0;
            transform: translateY(-50%);
          }

          .route-and-tasks-mobile-swiper .swiper-button-prev {
            left: 0;
            color: rgba(255, 255, 255, 0.36);
          }

          .route-and-tasks-mobile-swiper .swiper-button-next {
            right: 0;
            color: rgba(255, 255, 255, 0.36);
          }

          .route-and-tasks-mobile-swiper .swiper-button-prev:active,
          .route-and-tasks-mobile-swiper .swiper-button-next:active,
          .route-and-tasks-mobile-swiper .swiper-button-prev:focus-visible,
          .route-and-tasks-mobile-swiper .swiper-button-next:focus-visible {
            color: #fff;
          }

          .route-and-tasks-mobile-swiper .swiper-button-disabled {
            opacity: 0.35;
            pointer-events: none;
          }

          .route-and-tasks-mobile-swiper .swiper-button-prev::after,
          .route-and-tasks-mobile-swiper .swiper-button-next::after {
            display: block;
            font-size: 28px;
            font-weight: 500;
          }

          /* swiper v12: стрелка — inline svg, глобально скрыта в globals.css */
          .route-and-tasks-mobile-swiper .swiper-button-prev svg,
          .route-and-tasks-mobile-swiper .swiper-button-next svg {
            display: block;
            width: 28px;
            height: 28px;
          }

          .route-and-tasks-mobile-swiper .swiper-pagination {
            margin-top: 12px;
            gap: 12px;
          }

          .route-and-tasks-mobile-swiper .swiper-pagination-bullet {
            margin: 0 !important;
            width: 12px;
            height: 12px;
            opacity: 1;
            background: rgba(255, 255, 255, 0.36);
          }

          .route-and-tasks-mobile-swiper .swiper-pagination-bullet-active {
            background: #12951a;
          }
        `}</style>
      </div>
    </>
  );
};
